/// <amd-module name="Repos/Views/Settings/Branches/Provider/BranchTreeProvider" />
import { EnhancedGitRef } from "Data/EnhancedGitRef";
import { GitRef } from "Repos/Common/Contracts/Git";
import { refToBranchName } from "Repos/Common/Util/Ref";
import { ISparseTreeProvider } from "Repos/SparseTree/SparseTreeProvider.Types";
import { IBranchTreeProvider } from "./BranchTreeProvider.Types";

export class BranchTreeProvider implements IBranchTreeProvider {
    private compareBranch: EnhancedGitRef | undefined;
    private defaultBranch: EnhancedGitRef | undefined;
    private readonly baseProviderInternal: ISparseTreeProvider<EnhancedGitRef>;
    private policyPaths: Set<string>;

    constructor(
        baseProvider: ISparseTreeProvider<EnhancedGitRef>,
        initialCompareBranch: EnhancedGitRef | undefined,
        initialDefaultBranch: EnhancedGitRef | undefined,
        policyPaths: string[]
    ) {
        this.initialize(initialCompareBranch, initialDefaultBranch, policyPaths);
        this.baseProviderInternal = baseProvider;
    }

    public get baseProvider() {
        return this.baseProviderInternal;
    }

    public createEnhancedRef = (gitRef: GitRef) => {
        const enhancedRef: EnhancedGitRef = {
            rootRef: gitRef,
            isCompare: false,
            isDefault: false,
            ref: gitRef.name
        };

        return enhancedRef;
    };

    public getCompareBranch = () => {
        return this.compareBranch;
    };

    public getDefaultBranch = () => {
        return this.defaultBranch;
    };

    public initialize = (
        initialCompareBranch: EnhancedGitRef | undefined,
        initialDefaultBranch: EnhancedGitRef | undefined,
        policyPaths: string[]
    ) => {
        this.compareBranch = initialCompareBranch;
        this.defaultBranch = initialDefaultBranch;

        this.policyPaths = new Set(policyPaths.map(refToBranchName));
    };

    public pathHasPolicy = (path: string) => {
        if (this.policyPaths.has(path)) {
            return true;
        }

        while (path !== "") {
            // Add this to test parent folders
            if (this.policyPaths.has(path + "/*")) {
                return true;
            }

            path = path.substring(0, Math.max(0, path.lastIndexOf("/")));
        }

        return false;
    };
}
